/** Abas de situação (indicador deslizante) e filtros rápidos (rolam na horizontal no celular). */
import React from "react";
import { motion } from "framer-motion";
import { FiAlertTriangle, FiCalendar, FiClock, FiMessageCircle } from "react-icons/fi";

import { MOLA } from "../comum/movimento";
import { FILTROS_RAPIDOS } from "../dados/filtros";
import { SITUACOES } from "../dados/montarClientes";

const ABAS = [
  { id: SITUACOES.TODOS, rotulo: "Todos" },
  { id: SITUACOES.PENDENTES, rotulo: "Pendentes" },
  { id: SITUACOES.EM_ANDAMENTO, rotulo: "Em andamento" },
  { id: SITUACOES.CONCLUIDOS, rotulo: "Concluídos" },
];

const RAPIDOS = [
  { id: FILTROS_RAPIDOS.ATRASO, rotulo: "Em atraso", Icone: FiClock },
  { id: FILTROS_RAPIDOS.ENTREGA_PROXIMA, rotulo: "Entrega em 7 dias", Icone: FiCalendar },
  { id: FILTROS_RAPIDOS.ESPERAM_EQUIPE, rotulo: "Esperam a equipe", Icone: FiMessageCircle, daCentral: true },
  { id: FILTROS_RAPIDOS.COM_PENDENCIAS, rotulo: "Com pendências", Icone: FiAlertTriangle, daCentral: true },
];

export default function Barra({ situacao, porSituacao, aoTrocarSituacao, rapido, aoFiltrar, contagemRapidos, comCentral }) {
  function teclaNasAbas(evento) {
    if (evento.key !== "ArrowRight" && evento.key !== "ArrowLeft") return;
    const atual = ABAS.findIndex((a) => a.id === situacao);
    const proxima = ABAS[(atual + (evento.key === "ArrowRight" ? 1 : ABAS.length - 1)) % ABAS.length];
    aoTrocarSituacao(proxima.id);
    evento.currentTarget.querySelector(`[data-aba="${proxima.id}"]`)?.focus();
  }

  return (
    <div className="cl-bar">
      <div className="cl-tabs cl-hscroll" role="tablist" aria-label="Situação" onKeyDown={teclaNasAbas}>
        {ABAS.map((aba) => {
          const ativa = situacao === aba.id;
          return (
            <button
              key={aba.id}
              type="button"
              role="tab"
              data-aba={aba.id}
              aria-selected={ativa}
              tabIndex={ativa ? 0 : -1}
              className="cl-tab"
              onClick={() => aoTrocarSituacao(aba.id)}
            >
              {ativa && <motion.span layoutId="cl-aba-situacao" className="cl-tab-ind" transition={MOLA} />}
              {aba.rotulo} <b>{porSituacao[aba.id] ?? 0}</b>
            </button>
          );
        })}
      </div>
      <div className="cl-filters cl-hscroll" role="group" aria-label="Filtros rápidos">
        {RAPIDOS.filter((f) => comCentral || !f.daCentral).map(({ id, rotulo, Icone }) => (
          <button key={id} type="button" className="cl-chip" aria-pressed={rapido === id} onClick={() => aoFiltrar(id)}>
            <Icone size={13} aria-hidden="true" />
            {rotulo}
            <b>{contagemRapidos[id] ?? 0}</b>
          </button>
        ))}
      </div>
    </div>
  );
}
